import React from "react";
import NodalReceievedFiles from "./NodalReceivedFiles";
import EmpReceivedFiles from "./EmpReceivedFiles";
import { useSelector } from "react-redux";

const AllReceivedFiles = () => {
  const { businessServices: userBusinessServices, tenantId, count, officerRole } = useSelector((state) => state.empInbox);

  const hasAuthorizedRoles = officerRole?.some((role) => role.code === "NODAL_OFFICER_AWAS" || role.code === "Nodal Officer");
  const authorizedOfficer = officerRole?.some((role) => role.code === "Authorized_Officer");
  const isSpecialOfficer = hasAuthorizedRoles || authorizedOfficer;
  if (isSpecialOfficer) {
    return <NodalReceievedFiles />;
  }
  return <EmpReceivedFiles />;
};

export default AllReceivedFiles
